export enum UserManagementType {
    LOCAL = "local",
    EXTERNAL = "external"
}

export interface Profile {
    userEditableFields: string[];
    email: string;
    firstName: string;
    lastName: string;
    userName: string;
    displayName: string;
    jobRole: string;
    profilePictureUrl: string;
    id: number;
    profileEnabled: boolean;
    displayNameSet: boolean;
    profileEmail: string;
    profilePhoneNumber: string;
    department: string;
    profilePicture: string;
    isActive: boolean;
    userManagementType: UserManagementType
}